import type { PersistedCreateSession } from '../lib/createSessionStore'
import { apiRequest } from './client'

export type TimelineSessionResponse = {
  timelinePublicId: string
  state: PersistedCreateSession
}

export type GetTimelineSessionOptions = {
  /** 是否与创作任务对账并写回 rounds（默认 true） */
  reconcile?: boolean
}

/**
 * 当前用户时间线（一人一条），state 与历史 localStorage 结构一致
 */
export function getTimelineSession(options?: GetTimelineSessionOptions) {
  const reconcile = options?.reconcile !== false
  const query = reconcile ? '?reconcile=true' : '?reconcile=false'
  return apiRequest<TimelineSessionResponse>(`/v1/timeline-sessions/me${query}`, {
    method: 'GET',
  })
}

/** 显式对账：合并创作任务终态，可补偿失败任务入队 */
export function reconcileTimelineSession() {
  return apiRequest<TimelineSessionResponse>('/v1/timeline-sessions/me/reconcile', {
    method: 'POST',
  })
}

export function putTimelineSession(state: PersistedCreateSession) {
  return apiRequest<void>('/v1/timeline-sessions/me', {
    method: 'PUT',
    body: JSON.stringify(state),
  })
}
